function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 1h-4.636c-2.05 0-4.015.738-5.464 2.05-1.45 1.313-2.264 3.093-2.264 4.95v4.2H7v5.6h4.636V29h6.182V17.8h4.636L24 12.2h-6.182V8c0-.371.163-.727.453-.99a1.63 1.63 0 011.093-.41H24V1z",
  fill: "currentColor"
});

function SvgIcoFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDFIMTkuMzYzNkMxNy4zMTQyIDEgMTUuMzQ4OCAxLjczNzUgMTMuODk5NiAzLjA1MDI1QzEyLjQ1MDUgNC4zNjMwMSAxMS42MzY0IDYuMTQzNDggMTEuNjM2NCA4VjEyLjJIN1YxNy44SDExLjYzNjRWMjlIMTcuODE4MlYxNy44SDIyLjQ1NDVMMjQgMTIuMkgxNy44MTgyVjhDMTcuODE4MiA3LjYyODcgMTcuOTgxIDcuMjcyNiAxOC4yNzA4IDcuMDEwMDVDMTguNTYwNyA2Ljc0NzUgMTguOTUzOCA2LjYgMTkuMzYzNiA2LjZIMjRWMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIcoFacebook as ReactComponent };